// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading {
  width:100%;
  height:100%;
  position:absolute;
  top:0;
  left:0;
  z-index: 10;
}
.background {
  width: 100%;
  height: 100%;
  /*background-color: black;*/
  /*opacity: 0.7;*/
  position: absolute;
  background:radial-gradient(ellipse farthest-corner at center, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.7) 100%);
}
.center {
  margin: auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  display:table;
}
.text{
  color:white;

}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/qr/qr.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,6GAA6G;AAC/G;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,WAAW;;AAEb","sourcesContent":[".loading {\n  width:100%;\n  height:100%;\n  position:absolute;\n  top:0;\n  left:0;\n  z-index: 10;\n}\n.background {\n  width: 100%;\n  height: 100%;\n  /*background-color: black;*/\n  /*opacity: 0.7;*/\n  position: absolute;\n  background:radial-gradient(ellipse farthest-corner at center, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.7) 100%);\n}\n.center {\n  margin: auto;\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  display:table;\n}\n.text{\n  color:white;\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
